export default async function IsMailValid ( email ) {
    var re = /^[\w-\.]+@[\w-]+\.[a-z]{2,4}$/i;
    var myMail = email;
    var valid = await re.test(myMail);
    return valid;
};
